<style lang="scss" src='./ProductLateral.scss' scoped></style>
<template src="./ProductLateral.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters,
  } from "vuex";
  let noImage = require('@/assets/android-chrome-192x192.png');
  import CustomSwitch from '@/components/customSwitch/CustomSwitch'
  export default {
    name: 'ProductLateral',
    props: {
      product: {
        type: Object
      }
    },
    components: {
      CustomSwitch
    },
    data() {
      return {
        cartProduct: {},
        noImage: noImage,
        loading: {
          add: false,
          update: false,
          delete: false,
        },
      };
    },
    computed: {
      ...mapState('CartStore', ['cartProducts']), 
      ...mapGetters("Main", ['getCurrentStore']),
    },

    watch: {
      cartProducts: {
        handler: function () {
          this.fnFindProduct();
        },
        deep: true,
      }
    },

    methods: {
      ...mapActions('CartStore', ['fnApiAddProduct', 'fnApiDeleteProduct', 'fnApiUpdateProduct']),

      fnFindProduct() {
        this.cartProduct = this.cartProducts.products.find(item => item._id == this.product._id);
      },

      async fnAdd() {
        let store_id = this.getCurrentStore.store_id;
        let tempProduct = {
          _id: this.cartProduct._id,
          unit: this.cartProduct.unit,
          ripeness: this.cartProduct.ripeness,
          store_id: store_id,
        }
        if (this.cartProduct.unit == "KG") {
          tempProduct.qty = this.cartProduct.qty + 0.250;
        } else {
          tempProduct.qty = this.cartProduct.qty + 1;
        }
        this.loading.update = true;
        await this.fnApiUpdateProduct(tempProduct);
        this.loading.update = false;
      },

      async fnSubtract() {
        let store_id = this.getCurrentStore.store_id;
        let tempProduct = {
          _id: this.cartProduct._id,
          unit: this.cartProduct.unit,
          ripeness: this.cartProduct.ripeness,
          store_id: store_id,
        }
        if (this.cartProduct.unit == "KG") {
          tempProduct.qty = this.cartProduct.qty - 0.250;
        } else {
          tempProduct.qty = this.cartProduct.qty - 1;
        }
        this.loading.update = true;
        await this.fnApiUpdateProduct(tempProduct);
        this.loading.update = false;
      },

      fnValidateSubstractBtn() {
        if(this.loading.update || this.loading.delete){
          return false;
        }

        if(this.cartProduct.original_unit == 'PZA'){
          return this.cartProduct.qty > 1
        }else{
          if (this.cartProduct.unit == "KG") {
            return this.cartProduct.qty > 0.25
          }else{
            return this.cartProduct.qty > 1
          }
        }
      },

      fnValidateAddBtn() {
        if(this.loading.update || this.loading.delete){
          return false;
        }

        if(this.cartProduct.original_unit == 'PZA'){
          return this.cartProduct.qty < this.cartProduct.amount
        }else{
          if (this.cartProduct.unit == "KG") {
            return (this.cartProduct.qty + 0.25) <= this.cartProduct.amount
          }else{
            let qty_kg = this.cartProduct.qty * this.cartProduct.piece_weight;
            return (qty_kg + 0.25) <= this.cartProduct.amount
          }
        }
      },

      async fnChangeUnits(swState) {
        let store_id = this.getCurrentStore.store_id;
        let tempProduct = {
          _id: this.cartProduct._id,
          qty: this.cartProduct.qty,
          ripeness: this.cartProduct.ripeness,
          store_id: store_id,
        }
        if (!swState) {
          tempProduct.unit = "KG";
        } else {
          tempProduct.unit = "PZA";
        }
        tempProduct.qty = 1;
        this.loading.update = true;
        await this.fnApiUpdateProduct(tempProduct);
        this.loading.update = false;
      },

      fnChangeRipeness(ripeness) {
        let store_id = this.getCurrentStore.store_id;
        let tempProduct = {
          _id: this.cartProduct._id,
          qty: this.cartProduct.qty,
          unit: this.cartProduct.unit,
          store_id: store_id,
          ripeness,
        }
        this.fnApiUpdateProduct(tempProduct);
      },
      async fnDelete() {
        this.loading.delete = true;
        let store_id = this.getCurrentStore.store_id;
        await this.fnApiDeleteProduct([store_id, this.product._id]);
        this.loading.delete = false;
      },

      fnCalculateOriginalSubtotal(){
        let qty = this.cartProduct.qty;
        let unit = this.cartProduct.unit;
        let original_unit = this.cartProduct.original_unit;
        let piece_weight = this.cartProduct.piece_weight;
        let price = this.cartProduct.original_price;
        if(original_unit == 'PZA'){
          return qty * price;
        }else{
          if(unit == 'KG'){
            return qty * price;
          }else{
            return qty * piece_weight * price;
          }
        }
      }
    },
    beforeCreate() {},
    created() {},
    mounted() {
      this.cartProduct = {
        ...this.product
      };
    },
    beforeDestroy() {},
  };

</script>
